import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEquipmentSafetyMask = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "equipment-safety-mask" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 5.25,
			y: 6.75,
			width: 13.5,
			height: 6,
			rx: .75,
			ry: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 9.75,
			x2: 15.75,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,13.5V5.25a4.5,4.5,0,0,0-4.5-4.5H6.75a4.5,4.5,0,0,0-4.5,4.5V13.5a9.75,9.75,0,0,0,19.5,0Z"
		})
	]
});
export default SvgEquipmentSafetyMask;
